<script lang="ts">
  import { app, persistSettings } from './store.svelte';
  import { t } from './i18n';
  import { BUILTIN_TEMPLATES, type Template } from '../core/templates';
  import Icon from './lib/Icon.svelte';

  function apply(tpl: Template) {
    app.settings = { ...app.settings, ...tpl.settings };
    persistSettings();
  }
</script>

<section class="panel">
  <h3><Icon name="layers" size={12} /> Şablonlar</h3>
  {#each BUILTIN_TEMPLATES as tpl (tpl.id)}
    <article class="card">
      <header>
        <h4>{t(app.lang, tpl.nameKey as 'tpl.quickClay')}</h4>
        <button class="apply" onclick={() => apply(tpl)}>
          <Icon name="check" size={12} />
          <span>{t(app.lang, 'tpl.apply')}</span>
        </button>
      </header>
      <p>{tpl.description}</p>
      <dl>
        <div class="stat"><dt>Layer</dt><dd>{tpl.settings.layerHeight}<small>mm</small></dd></div>
        <div class="stat"><dt>Speed</dt><dd>{tpl.settings.printSpeed}<small>mm/dk</small></dd></div>
        <div class="stat"><dt>Vase</dt><dd>{tpl.settings.vaseMode ? '✓' : '—'}</dd></div>
      </dl>
    </article>
  {/each}
</section>

<style>
  .panel { display: flex; flex-direction: column; gap: 10px; padding: 0; }
  h3 {
    margin: 0; font-size: 10px; color: var(--text-3);
    text-transform: uppercase; letter-spacing: 0.1em; font-weight: 600;
    display: inline-flex; align-items: center; gap: 6px;
  }
  .card {
    position: relative;
    background: linear-gradient(180deg, rgba(255,255,255,0.03), rgba(255,255,255,0.01));
    border: 1px solid var(--border-soft);
    border-radius: 10px;
    padding: 12px;
    overflow: hidden;
    transition: border-color 0.18s ease, transform 0.15s ease, box-shadow 0.18s ease;
  }
  .card::before {
    content: '';
    position: absolute; left: 0; top: 0; bottom: 0;
    width: 2px;
    background: linear-gradient(180deg, transparent, #4ab8ff 50%, transparent);
    opacity: 0; transition: opacity 0.2s ease;
  }
  .card:hover {
    border-color: rgba(74, 184, 255, 0.32);
    transform: translateY(-1px);
    box-shadow: 0 10px 24px -12px rgba(74, 184, 255, 0.4);
  }
  .card:hover::before { opacity: 1; }
  header {
    display: flex; justify-content: space-between; align-items: center;
    margin-bottom: 6px; padding: 0; background: none; border: none;
  }
  h4 {
    margin: 0; font-size: 13px; color: var(--text-bright); font-weight: 600;
    letter-spacing: -0.005em;
  }
  .apply {
    display: inline-flex; align-items: center; gap: 5px;
    background: linear-gradient(180deg, #1a7ac9, #0f5994);
    color: white; border: 1px solid rgba(255,255,255,0.1);
    padding: 5px 11px; border-radius: 7px;
    font-size: 11px; font-weight: 600; cursor: pointer;
    font-family: inherit;
    box-shadow: 0 0 0 1px rgba(255,255,255,0.06) inset, 0 4px 10px -3px rgba(74,184,255,0.45);
    transition: filter 0.12s, transform 0.1s;
  }
  .apply:hover { filter: brightness(1.1); }
  .apply:active { transform: scale(0.96); }
  p { margin: 0 0 10px; font-size: 11px; color: var(--text-muted); line-height: 1.5; }
  dl {
    margin: 0; display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
    font-size: 10px;
  }
  .stat {
    display: flex; flex-direction: column; gap: 2px;
    padding: 6px 8px;
    background: rgba(255,255,255,0.03);
    border: 1px solid var(--border-soft);
    border-radius: 6px;
  }
  dt {
    font-weight: 500; color: var(--text-muted);
    text-transform: uppercase; letter-spacing: 0.05em; font-size: 9px;
  }
  dd {
    margin: 0; color: var(--text-bright); font-weight: 600; font-size: 12px;
    font-variant-numeric: tabular-nums;
  }
  dd small { font-size: 9px; color: var(--text-3); margin-left: 2px; font-weight: 500; }
</style>
